import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const { t } = useI18n();

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);

    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[150] bg-amber-500/90 text-black text-center py-1.5 px-4 text-xs font-mono font-medium" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 6px)' }}>
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="w-3.5 h-3.5" />
        {t.offline}
      </div>
    </div>
  );
}
